import { Loader as Assets } from '@CS/assets';
import Spinner from '@CS/assets/loader.svg?component';
import LottieAnimation from '@CS/components/LottieAnimation';
import { documentLang } from '@CS/components/TranslationProvider';
import {
  LoaderStyle,
  ImageStyle,
  SpinnerStyle,
  LoadingText
} from './Loader.styles';

const loadingCopy = {
  it: 'Caricamento...',
  fr: 'Chargement...',
  de: 'Laden...'
};

const getLoadingCopy = () => {
  const lang = documentLang();

  return loadingCopy[lang as keyof typeof loadingCopy] ?? '';
};

export type LoaderProps = {
  overlay?: boolean;
  opacity?: number;
  image?: string;
  color?: string;
  speed?: number;
  width?: number;
  lottie?: JSON;
};

export const Loader = ({
  overlay = false,
  color = 'white',
  opacity = 0.5,
  speed = 2.5,
  width = 50,
  lottie,
  image
}: LoaderProps) => {
  const loader = lottie ? (
    <ImageStyle width={width}>
      <LottieAnimation animationData={Assets.lottie} />
      <LoadingText>{getLoadingCopy()}</LoadingText>
    </ImageStyle>
  ) : image ? (
    <ImageStyle width={width}>
      <img src={Assets.gif} />
    </ImageStyle>
  ) : (
    <SpinnerStyle color={color} speed={speed} width={width}>
      <Spinner />
    </SpinnerStyle>
  );

  return (
    <LoaderStyle $overlay={overlay} opacity={opacity}>
      {loader}
    </LoaderStyle>
  );
};
